import { useQuery } from "@tanstack/react-query";
import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import GatewayService from "../services/GatewayService";
import UsersService from "@velocity-ehs/user-utils-module";
import {
  getPagination,
  PaginationQueryObject,
  QuerySort,
} from "../components/supportFunctions/graphql/Queries";
import { ApplicationRelationship } from "./useGetPolicies";

interface RolePoliciesQuery {
  items: Array<{
    id: string;
    name: string;
    description: string;
    applicationRelationship: ApplicationRelationship; // Deprecated, use applicationBundleId
    applicationBundleId: string;
    policies: {
      items: Array<{
        description: string;
        externalAccessAllowed: boolean;
        id: string;
        isVisible: boolean;
        name: string;
      }>;
      pageInfo: {
        totalElements: number;
      };
    };
  }>;
}

function useGetRolePolicies(roleId: string, params: any) {
  const { showSnackbar } = useSnackbarActionContext();
  const { filter, pagination } = formatParams(roleId, params);

  const result = useQuery<RolePoliciesQuery>({
    queryKey: ["customerPolicies", roleId, params],
    queryFn: () =>
      GatewayService.getRolePolicies(
        UsersService.customer.id,
        filter,
        pagination
      ),
    retry: false,
    enabled: !!roleId,
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });
  return {
    ...result,
    policies: result.data?.items[0].policies.items || [],
    pagination: (result.data?.items[0].policies.pageInfo ||
      {}) as RolePoliciesQuery["items"][number]["policies"]["pageInfo"],
  };
}

function formatParams(roleId: string, params: any) {
  let querySort: QuerySort = null;

  if (params.sortField && params.sortOrder) {
    querySort = {
      sortField: params.sortField,
      sortDirection: params.sortOrder,
    } as QuerySort;
  }

  let pagination: PaginationQueryObject = getPagination(
    params.page + 1,
    params.rows,
    querySort
  );

  const filter = {
    and: {
      id: roleId,
    },
  };

  return { filter, pagination };
}

export { useGetRolePolicies };
